/**
 * `@eis/billingservice-sdk` — the generated client for the billing service (SDD-015).
 *
 * `./generated` comes from api/openapi/billing.v1.openapi.yaml — OUR contract, derived from
 * api/proto/billing/v1 by `make gen` — via `pnpm gen:sdk`; never hand-edited, diffed by
 * `make gen-check` (rule 26). The types are re-exported under one namespace, so a call site says
 * `BillingApi.Invoice` and never re-declares the legacy shape.
 *
 * The paths already carry `/billingservice/v1/…` (B-1: the service owns its legacy prefix), so the
 * client's base is the ORIGIN the API is mounted under — `/api` behind the console's reverse proxy,
 * where Caddy strips only `/api` (`handle /api/billingservice/*`) — never `/api/billingservice`.
 *
 * Built with `createEisClient`, so the platform's ETag / If-Match middleware is ON (T-12) — the
 * schedule (`policies-billings/{code}`) and the bill runs are mutable rows that return an ETag and
 * are guarded by it. Invoices and bills are INSERT-ONLY (B-4): their reads carry no ETag, so the
 * middleware parks nothing for them and injects no `If-Match` on the creation paths — the
 * contract test in `src/__tests__` pins that.
 */
import { createEisClient, type EisClient, type EisClientOptions } from '@eis/sdk-runtime';
import type { paths } from './generated/billing.v1';

export type * as BillingApi from './generated/billing.v1';

export {
  ConflictError,
  isConflictError,
  createEtagStore,
  type ConflictKind,
  type EtagStore,
  type TokenProvider,
  type TraceparentProvider,
  type EisClientOptions,
  // The session middleware's client half (SDD-019 S-6): what is retried, and when.
  createSessionRefreshMiddleware,
  isSafeToReplay,
  type SessionRefreshOptions,
} from '@eis/sdk-runtime';

// The list standard's client half (SDD-017 §10, L-13): builders, the pager, the catalog types.
export {
  escapeFilterValue,
  filters,
  isListError,
  listErrorOf,
  ListPageError,
  OPERATORS,
  paginate,
  search,
  type FieldType,
  type FilterCatalog,
  type FilterField,
  type FilterValue,
  type ListErrorCode,
  type ListErrorDetail,
  type ListPage,
  type Operator,
} from '@eis/sdk-runtime';

export type BillingClient = EisClient<paths>;

export function createBillingClient(options: EisClientOptions): BillingClient {
  return createEisClient<paths>(options);
}
